import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslationService } from 'src/metronic/core/_base/layout';
import { LanguageType } from 'src/metronic/core/_config/i18n/language-type.model';
import { ApiUrls } from '../../../api-urls.constants';
import { AvailableInterview, GoogleEmail, SelectedInterview } from './components/interviews-modal/interview.model';
import { Study } from './study.model';

@Injectable({
  providedIn: 'root'
})
export class MyStudiesService {
  public static readonly StudiesBlockConfirmationDialogOptions = {
    title: 'DASHBOARD.MY-STUDIES.STUDIES-CHANGE-LOCK.TITLE',
    content: 'DASHBOARD.MY-STUDIES.STUDIES-CHANGE-LOCK.TEXT',
    confirm: 'DASHBOARD.MY-STUDIES.STUDIES-CHANGE-LOCK.CONFIRM'
  };

  public static readonly PhotoBlockConfirmationDialogOptions = {
    title: 'DASHBOARD.MY-STUDIES.PHOTO-CHANGE-LOCK.TITLE',
    content: 'DASHBOARD.MY-STUDIES.PHOTO-CHANGE-LOCK.TEXT',
    confirm: 'DASHBOARD.MY-STUDIES.PHOTO-CHANGE-LOCK.CONFIRM'
  };

  constructor(
    private http: HttpClient,
    private translationService: TranslationService
  ) {
  }

  getUserStudies(): Observable<Study[]> {
    return this.http
      .get<Study[]>(
        ApiUrls.SelectedStudies,
        {
          params: {
            lang: this.translationService.getCurrentLanguage()
          }
        }
      ).pipe(
        map(studies => studies.map(s => ({
          ...s,
          iconClass: this.getStudiesIcon(s)
        })))
      );
  }

  getAvailableInterviews(studyId: number): Observable<AvailableInterview[]> {
    return this.http
      .get<AvailableInterview[]>(
        ApiUrls.AvailableInterviews,
        {
          params: {
            lang: this.translationService.getCurrentLanguage(),
            studyId: studyId.toString()
          }
        }
      );
  }

  getCandidateGoogleEmail(): Observable<GoogleEmail> {
    return this.http
      .get<GoogleEmail>(
        ApiUrls.GoogleEmail
      );
  }

  changeCandidateInterviewGoogleEmail(googleEmail: string): Observable<GoogleEmail> {
    return this.http
      .put<GoogleEmail>(ApiUrls.GoogleEmail, { googleEmail });
  }

  signUpForInterview(interview: SelectedInterview): Observable<SelectedInterview> {
    return this.http
      .post<SelectedInterview>(ApiUrls.SelectedInterview, interview);
  }

  resignFromInterview(interviewId: number, isRemote: boolean): Observable<{}> {
    return this.http
      .delete<{}>(ApiUrls.SelectedInterview, {
        params: {
          interviewId: interviewId.toString(),
          isRemote: String(isRemote)
        }
      });
  }

  changeLanguage(): Observable<any> {
    const lang = LanguageType[this.translationService.getCurrentLanguage()];
    const formData = new FormData();
    formData.append('culture', lang === LanguageType.Polish ? 'pl-PL' : 'en-US');
    formData.append('returnUrl', '');
    return this.http.post('Identity/Language/SetLanguage', formData);
  }

  updatePermissionToChangePhoto(canChange: boolean): Observable<void> {
    return this.http.post<void>(ApiUrls.CandidatePermissions_UpdatePermissionToChangePhoto, { canChange });
  }

  private getStudiesIcon(study: Study): string {
    if (!study.isInterviewRequired) {
      return 'flaticon2-check-mark';
    } else if (!study.isInterviewScheduled) {
      return 'fa fa-exclamation';
    } else {
      return 'flaticon2-check-mark';
    }
  }
}
